<template>
	<div v-if="!invitationInvalid" class="narrow-container d-flex flex-column align-center">
		<span class="onboarding-title text-center mb-10 mt-4">
			To accept invitation for
			<span class="font-bold">{{ $route.query.email }}</span>
			<br />
			we need to create an account first.
		</span>
		<span class="onboarding-text font-normal text-center">After account has been created, the invitation will be accepted.</span>

		<v-card-text>
			<v-form @keyup.native.enter="createAccount" :disabled="processing">
				<v-text-field
					v-model="form.name"
					:error-messages="form.$errors.name"
					label="Enter your name"
					outlined
					@blur="form.validate('name')"
					@input="delete form.$errors.name"
				/>

				<v-tooltip v-model="showPasswordTooltip" content-class="password-tooltip" right>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							v-model="form.password"
							:error-messages="form.$errors.password"
							label="Password"
							type="password"
							outlined
							required
							v-bind="attrs"
							v-on="on"
							@blur="
								form.validate('password');
								showPasswordTooltip = false;
							"
							@input="delete form.$errors.password"
							@focus="showPasswordTooltip = true"
						/>
					</template>
					<div>
						<v-list-item class="mb-n4" :class="{ 'text-decoration-line-through': passValidation.uppercase }">
							One uppercase letter
						</v-list-item>
						<v-list-item class="mb-n4" :class="{ 'text-decoration-line-through': passValidation.lowercase }">
							One lowercase letter
						</v-list-item>
						<v-list-item class="mb-n4" :class="{ 'text-decoration-line-through': passValidation.number }">One number</v-list-item>
						<v-list-item class="mb-n4" :class="{ 'text-decoration-line-through': passValidation.specialChar }">
							One special character
						</v-list-item>
						<v-list-item :class="{ 'text-decoration-line-through': passValidation.length }">8+ characters</v-list-item>
					</div>
				</v-tooltip>

                <v-btn color="primary" :loading="form.$busy" large depressed block rounded @click="createAccount" :disabled="processing">
                    <v-progress-circular v-if="processing" indeterminate color="var(--primary)" size="18" width="3"></v-progress-circular>
                    <span v-else>Create Account</span>
                </v-btn>
			</v-form>
		</v-card-text>
	</div>

	<div v-else class="narrow-container">
		<span class="onboarding-title text-center d-block mt-4">
			Invalid or already used invitation.
		</span>
	</div>
</template>

<script>
import * as rules from "vuelidate/lib/validators";

export default {
	data: function() {
		return {
			invitationInvalid: false,
			showPasswordTooltip: false,
			processing: false,
			form: new Form(this, "form", {
				name: null,
				password: null,
			}),
		};
	},

	validations: {
		form: {
			name: {
				required: rules.required,
				minLength: rules.minLength(4),
				fullName: rules.helpers.regex("fullName", /^[a-zA-Z]{1,}( [a-zA-Z]{1,}){1,}$/),
			},
			password: {
				required: rules.required,
				password: rules.helpers.regex("password", /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[*.!@#$%^&(){}[:;<>,.?~_/+=|]).{8,32}$/),
			},
		},
	},

	computed: {
		passValidation() {
			return {
				uppercase: this.form.password ? /[A-Z]/.test(this.form.password) : false,
				lowercase: this.form.password ? /[a-z]/.test(this.form.password) : false,
				number: this.form.password ? /[0-9]/.test(this.form.password) : false,
				specialChar: this.form.password ? /[*.!@#$%^&(){}[:;<>,.?~_/+=|]/.test(this.form.password) : false,
				length: this.form.password ? /^.{8,}$/.test(this.form.password) : false,
			};
		},
	},

	created() {
		if (!this.$route.query.invitation_token) {
			this.$router.push({ name: "app" });
		}
	},

	methods: {
		createAccount() {
			if (!this.form.validate()) {
				return;
			}

			this.processing = true;

			// NOTE move to vuex module
			this.$apiService
				.patch(
					"users/setPassword",
					{
						name: this.form.name,
						password: this.form.password,
					},
					{
						params: {
							invitation_token: this.$route.query.invitation_token,
						},
					}
				)
				.then(response => {
					this.$store.dispatch('Auth/processLoginResponse', response);
				})
				.catch(err => {
					this.invitationInvalid = true;
				});
		},
	},
};
</script>

<style lang="scss" scoped>
.password-tooltip {
	background-color: white;
	box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px 0 rgba(0, 0, 0, 0.14), 0 1px 14px 0 rgba(0, 0, 0, 0.12);
}

#create-account-via-invitation {
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	.form {
		max-width: 630px;

		.center {
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
}
</style>
